"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decimalToBigNumber = exports.bigNumberToDecimal = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const decimal_pb_1 = require("./decimal_pb");
/**
 * Converts a BigNumber instance to a Decimal object.
 *
 * @param {BigNumber} bigNumber - The BigNumber instance to convert.
 * @returns {Decimal} A Decimal object with the value and exponent set.
 *
 * @remarks
 * This function uses the exponential string representation of the BigNumber
 * to construct a Decimal object.
 */
function bigNumberToDecimal(bigNumber) {
    var _a;
    const [valueStr, exponentStr] = bigNumber.toExponential().split("e");
    const valueStrInt = valueStr.replace(".", "").replace("-", "");
    const absValue = parseInt(valueStrInt, 10);
    const exponent = parseInt(exponentStr, 10) - (valueStrInt.length - 1);
    return new decimal_pb_1.Decimal()
        .setValue(absValue * ((_a = bigNumber.s) !== null && _a !== void 0 ? _a : 0))
        .setExponent(exponent);
}
exports.bigNumberToDecimal = bigNumberToDecimal;
/**
 * Converts a Decimal object to a BigNumber instance.
 *
 * @param {Decimal} decimal - The Decimal object to convert.
 * @returns {BigNumber} A BigNumber instance with the value and exponent set.
 *
 * @remarks
 * This function uses the value and exponent of the Decimal object
 * to construct a BigNumber instance.
 */
function decimalToBigNumber(decimal) {
    var _a, _b;
    const value = (_a = decimal.getValue()) !== null && _a !== void 0 ? _a : 0;
    const exponent = (_b = decimal.getExponent()) !== null && _b !== void 0 ? _b : 0;
    return new bignumber_js_1.default(`${value}e${exponent}`);
}
exports.decimalToBigNumber = decimalToBigNumber;
